import envConfig from '@hulu/env-config';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { Auth } from 'aws-amplify';

import { User } from '../user';
import { HelpSiteCookieHelper } from '../user/interfaces';

export async function rerouteToHubIfNeeded(cognitoUser: CognitoUser): Promise<void> {
  try {
    const session = cognitoUser.getSignInUserSession();
    const idToken = session?.getIdToken()?.getJwtToken();

    if (idToken && User.shouldRedirectToHub(idToken)) {
      await HelpSiteCookieHelper.setHelpSiteCookieForNonAdmin();
      window.location.href = envConfig.REACT_APP_REDIRECT_TO_HUB_URL;
    }
  } catch (err) {
    console.error('Error during rerouteToHubIfNeeded:', err);
  }
}

export async function rerouteToHubIfNeededWithAuth(): Promise<void> {
  try {
    const session = await Auth.currentSession();
    if (session && session.isValid()) {
      const idToken = session.getIdToken().getJwtToken();
      if (idToken && User.shouldRedirectToHub(idToken)) {
        await HelpSiteCookieHelper.setHelpSiteCookieForNonAdmin();
        window.location.href = envConfig.REACT_APP_REDIRECT_TO_HUB_URL;
      }
    }
  } catch (err) {
    // Only log error if it's not a "No current user" error which is expected
    // when the user hasn't authenticated yet
    if (
      err &&
      typeof err === 'object' &&
      'message' in err &&
      err.message !== 'No current user' &&
      err.message !== 'No current authenticated user'
    ) {
      console.error('Error during rerouteToHubIfNeededNew:', err);
    }
  }
}
